export const getGravatarUrl = async (email) => {
  if (!email) return null;

  const normalized = email.trim().toLowerCase();
  const encoded = new TextEncoder().encode(normalized);
  const hashBuffer = await crypto.subtle.digest('SHA-256', encoded);
  const hashHex = Array.from(new Uint8Array(hashBuffer))
    .map((b) => b.toString(16).padStart(2, '0'))
    .join('');

  return `https://gravatar.com/avatar/${hashHex}?s=80&d=404`;
};

export const getInitials = (fullName) => {
  if (!fullName) return '';

  const nameParts = fullName.trim().split(' ').filter(Boolean);
  const firstInitial = nameParts[0]?.[0] || '';
  const lastInitial = nameParts.length > 1 ? nameParts[nameParts.length - 1][0] : '';

  return `${firstInitial}${lastInitial}`.toUpperCase();
};
